var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "proofreading-select-manuscript" }, [
    _c("h1", { staticClass: "proofreading-select-manuscript__heading" }, [
      _vm._v(
        " " + _vm._s(_vm.$t("proofreadingSelectManuscriptPage.heading")) + " "
      ),
    ]),
    _vm.isLoadingManuscripts || _vm.isLoadingCounts
      ? _c(
          "div",
          { staticClass: "proofreading-select-manuscript__loading" },
          [
            _c("LoadingSpinner", {
              attrs: {
                size: "small",
                variant: "inline",
                text: _vm.$t("proofreadingSelectManuscriptPage.loadingCounts"),
              },
            }),
          ],
          1
        )
      : !_vm.hasManuscripts
      ? _c("p", { staticClass: "proofreading-select-manuscript__empty" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("proofreadingSelectManuscriptPage.empty")) + " "
          ),
        ])
      : _c(
          "div",
          { staticClass: "proofreading-select-manuscript__selector" },
          [
            _c("ExportManuscriptListSelector", {
              attrs: {
                manuscripts: _vm.manuscriptList,
                "selected-manuscripts": _vm.selectedManuscripts,
                "character-counts-by-key": _vm.isAiMode
                  ? _vm.characterCountsByKey
                  : undefined,
                "character-count-unit": _vm.isAiMode ? "character" : "fish",
              },
              on: {
                "update:selectedManuscripts": function ($event) {
                  _vm.selectedManuscripts = $event
                },
                "update:selected-manuscripts": function ($event) {
                  _vm.selectedManuscripts = $event
                },
              },
            }),
          ],
          1
        ),
    _vm.hasCountLoadFailure
      ? _c(
          "div",
          { staticClass: "proofreading-select-manuscript__fish-info" },
          [
            _c("div", { staticClass: "fish-warning" }, [
              _c("div", { staticClass: "fish-warning-icon" }, [_vm._v("⚠️")]),
              _c("div", { staticClass: "fish-warning-content" }, [
                _c("p", { staticClass: "fish-warning-message" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("proofreadingSelectManuscriptPage.countLoadFailed")
                    )
                  ),
                ]),
              ]),
            ]),
          ]
        )
      : _vm.isAiMode && _vm.selectedManuscripts.length > 0
      ? _c(
          "div",
          { staticClass: "proofreading-select-manuscript__fish-info" },
          [
            _c(
              "div",
              { staticClass: "fish-info-content" },
              [
                _c(
                  "i18n",
                  {
                    attrs: {
                      path: "proofreadingSelectManuscriptPage.aiCharCount",
                      tag: "span",
                    },
                  },
                  [
                    _c(
                      "strong",
                      {
                        staticClass: "fish-info-amount",
                        attrs: { place: "amount" },
                      },
                      [_vm._v(_vm._s(_vm.formattedTotalChars))]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.showFishWarning
              ? _c("div", { staticClass: "fish-warning" }, [
                  _c("div", { staticClass: "fish-warning-icon" }, [
                    _vm._v("⚠️"),
                  ]),
                  _c("div", { staticClass: "fish-warning-content" }, [
                    _c("p", { staticClass: "fish-warning-message" }, [
                      _vm._v(_vm._s(_vm.fishWarningMessage)),
                    ]),
                    _vm.isFishInsufficient
                      ? _c(
                          "p",
                          { staticClass: "fish-warning-detail" },
                          [
                            _c(
                              "i18n",
                              {
                                attrs: {
                                  path:
                                    "proofreadingSelectManuscriptPage.fishShortageDetail",
                                  tag: "span",
                                },
                              },
                              [
                                _c(
                                  "strong",
                                  {
                                    staticClass: "fish-shortage-amount",
                                    attrs: { place: "amount" },
                                  },
                                  [_vm._v(_vm._s(_vm.formattedFishShortage))]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _c("div", { staticClass: "proofreading-select-manuscript__footer" }, [
      _c(
        "button",
        {
          staticClass: "proofreading-select-manuscript__back-button",
          attrs: { type: "button" },
          on: { click: _vm.onClickBack },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("proofreadingSelectManuscriptPage.back")) + " "
          ),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "proofreading-select-manuscript__next-button",
          attrs: { type: "button", disabled: !_vm.canProceed },
          on: { click: _vm.onClickNext },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("proofreadingSelectManuscriptPage.next")) + " "
          ),
        ]
      ),
    ]),
    _vm.isAiMode
      ? _c("div", { staticClass: "proofreading-select-manuscript__notice" }, [
          _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t("proofreadingSelectManuscriptPage.aiNoticeMaxChars")
              )
            ),
          ]),
          _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t("proofreadingSelectManuscriptPage.aiNoticeSelectOrder")
              )
            ),
          ]),
          _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t("proofreadingSelectManuscriptPage.aiNoticeNoLearning")
              )
            ),
          ]),
          _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t("proofreadingSelectManuscriptPage.aiNoticeCharCount")
              )
            ),
          ]),
          _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "proofreadingSelectManuscriptPage.aiNoticeBasicUnavailable"
                )
              )
            ),
          ]),
          _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(
                _vm.$t("proofreadingSelectManuscriptPage.aiNoticeNovelOnly")
              )
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }